import React from "react"; const GallerySection = () => <div>Gallery</div>; export default GallerySection;
